<template>
	<div class="menzhenjiuyi">
		<ul>
			<li v-for="(item,index) in attaArr">
				<div class="list">
					<img src="./../../assets/img/checked.png">
					<p>{{languageIndex==0?item.dict.name : item.dict.nameEn}}</p>							
					<template v-if="languageIndex==0">
						<p class="text1" v-show="item.obj.fee==-1">无限额</p>
						<p class="text1" v-show="item.obj.fee>0">限额:{{item.obj.fee}}</p>
					</template>
					<template  v-else>
						<p class="text1" v-show="item.obj.fee==-1">unlimited</p>
						<p class="text1" v-show="item.obj.fee>0">Unlimited:{{item.obj.fee}}</p>
					</template>
				</div>
				<p v-if="languageIndex == 0" class="text2">说明：{{setTxt(item.obj.description,'zh')  || '无'}}</p>
				<p v-if="languageIndex == 1" class="text2">Instructions：{{setTxt(item.obj.description,'en') || 'None'}}</p>
				<p v-if="languageIndex == 0" class="text2">回复：{{setTxt(item.obj.reply,'zh')  || '无'}}</p>
				<p v-if="languageIndex == 1" class="text2">Reply：{{setTxt(item.obj.reply,'en') || 'None'}}</p>
				<!--<textarea placeholder="添加回复" v-model="txt[index-1]" @input="txtdata" ></textarea>-->
			</li>
		</ul>
	</div>
</template>

<script>
	import constants from '@/util/constants.js';
	export default{
		props:[
			'attaArr'
		],
		computed:{
			languageIndex(){
				return this.$store.state.language
			}
		},
		methods:{
			setTxt(str,status){
				return constants.setTxt(str,status)
			}
		}				
	}
</script>

<style scoped="scoped">
	.menzhenjiuyi{margin-top: 10px;margin-left: 37px;}
	.menzhenjiuyi li{margin-bottom: 30px;}
	.menzhenjiuyi .list{overflow: hidden;margin-bottom: 5px;}
	.menzhenjiuyi .list *{float: left;margin-right: 10px;}
	.menzhenjiuyi .list img {height: 18px;margin-top: 3px;cursor: not-allowed;}
	.menzhenjiuyi textarea {display: block;width: 60%;margin-top: 10px;padding: 10px;height: 50px;border-radius: 5px;border: 1px solid #d9ddde;outline: none;margin-left: 33px;}
	.menzhenjiuyi .text1{color: #df1717;}
	.menzhenjiuyi .text2{margin-left: 33px;color: #999;}
</style>


// WEBPACK FOOTER //
// src/components/attachment/qingdan.vue